import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'
import { WEBHOOK_SETTINGS_API } from '../api/webhooks-api'
import { WebhookInterface } from '../types/webhook-settings-interface'

export const useWebhookSettings = () => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum, WebhookInterface[]>({
    method: RequestMethodsEnum.get,
  })

  const {
    data: webhooks,
    mutate,
    isValidating,
  } = useSWR(() => {
    if (user) return WEBHOOK_SETTINGS_API

    return null
  }, fetcher)

  return { webhooks, mutate, isLoading: isValidating }
}
